import { DateTime } from 'luxon'

import { SubscriptionPlanPrice } from '@/core/api/entities/account/subscriptionPlanPrice'

export class SubscriptionItem {
	public id: number
	public subscriptionId: number
	public productId: number
	public quantity: number
	public amount: number
	public discount: number
	public createdAt?: DateTime
	public updatedAt?: DateTime

	constructor(data: {
		id: number
		subscriptionId: number
		productId: number
		quantity: number
		amount: number
		discount: number
		createdAt?: DateTime
		updatedAt?: DateTime
	}) {
		this.id = data.id
		this.subscriptionId = data.subscriptionId
		this.productId = data.productId
		this.quantity = data.quantity
		this.amount = data.amount
		this.discount = data.discount
		this.createdAt = data.createdAt
		this.updatedAt = data.updatedAt
	}

	static create(data: Partial<SubscriptionItem>) {
		const defaultData = {
			id: 0,
			subscriptionId: 0,
			productId: 0,
			quantity: 0,
			amount: 0,
			discount: 0,
		}

		return new SubscriptionItem({ ...defaultData, ...data })
	}

	/**
	 * Return the price of the subscription item, regardless of whether it is a custom price or price list.
	 *
	 * @param prices
	 * @param planId
	 * @param currency
	 * @returns
	 */
	getAmount(
		prices: SubscriptionPlanPrice[],
		planId: number,
		currency: string
	): number | null {
		if (this.amount) {
			return this.amount
		}

		const filteredPrices = prices.filter((price: SubscriptionPlanPrice) => {
			return (
				price.productId === this.productId &&
				price.planId === planId &&
				price.currency === currency
			)
		})

		if (filteredPrices.length > 0) {
			return filteredPrices[0].price
		}

		return null
	}
}
